var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"split"}},[(_vm.lightMode)?_c('img',{attrs:{"src":require('@/assets/newimg/shop_light.webp' ),"alt":"Illustration"}}):_c('img',{attrs:{"src":require('@/assets/newimg/shop_dark.webp' ),"alt":"Illustration"}})])}
var staticRenderFns = []

export { render, staticRenderFns }